export function validarRut(rutInput: string) {
  // Remover espacios en blanco del RUT
  const rutSinEspacios = rutInput.replaceAll(" ", "");
  const validador = parseInt(rutSinEspacios.slice(-1));

  let rut = "";
  if (rutSinEspacios.length == 12) {
    rut = rutSinEspacios;
  } else if (rutSinEspacios.length == 11) {
    rut = "0" + rutSinEspacios;
  }

  if (rut.length !== 12) {
    return false;
  }

  let suma = 0;
  const bases = [4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
  for (let b = 0; b <= 10; b++) {
    suma += parseInt(rut[b]) * bases[b];
  }

  let digitivalidador = 11 - (suma % 11);

  if (digitivalidador == 11) {
    digitivalidador = 0;
  } else if (digitivalidador == 10) {
    digitivalidador = -1;
  }

  return validador == digitivalidador;
}
